"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _DiscordPlugin = /*#__PURE__*/ _interop_require_default(require("./DiscordPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _DiscordPlugin.default,
    id: 'discord',
    title: 'Discord',
    version: '0.0.1',
    logo: 'plugins/discord.png',
    description: 'Discord is the easiest way to talk over voice, video, and text. Talk, chat, hang out, and stay close with your friends and communities.',
    price: 'Free',
    tags: 'Chat',
    category: 'Chat',
    inputs: {
        title: 'Configure Discord',
        array: true,
        items: [
            {
                key: 'channel',
                label: 'Channel Name',
                placeholder: 'Channel Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'webhook_url',
                label: 'Webhook URL',
                type: _nocodbsdk.XcType.Password,
                placeholder: 'Webhook URL',
                required: true
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully installed and Discord is enabled for notification.',
        msgOnUninstall: ''
    }
};
const _default = config;
